export enum ConditionType
{
    //Engine = 0,
    Battery = 1,
    //Oil = 2,
    Recall = 3,
    Service = 4,
    Tyres = 5,
    //TyrePressure = 6,
    //TyreRotation = 7,
    Rego = 8,
    Wash = 9,

    WiperBlades = 10,
    Brakes = 11,

}

export namespace ConditionType
{

    /**
     * Gets a string representation of the enum
     * @param type 
     * @returns 
     */
    export function toString( type: ConditionType ): string
    {
        switch( type )
        {
            //case ConditionType.Engine: return "Engine";
            case ConditionType.Battery: return "Battery";
            //case ConditionType.Oil: return "Oil";
            case ConditionType.Recall: return "Recall";
            case ConditionType.Service: return "Service";
            case ConditionType.Tyres: return "Tyres";
            //case ConditionType.TyrePressure: return "Tyre pressure";
            //case ConditionType.TyreRotation: return "Tyre rotation";
            case ConditionType.Rego: return "Rego";
            case ConditionType.Wash: return "Wash";

            case ConditionType.WiperBlades: return "Wiper Blades";
            case ConditionType.Brakes: return "Brakes";

            default: return "UNKNOWN";

        }
    }
    
    /**
     * Gets a string representation of the enum for Google Tag Manager
     * @param type 
     * @returns 
     */
    export function getMoreInfoPage( type: ConditionType ): string
    {
        switch( type )
        {
            case ConditionType.Battery: return "battery";
            //case ConditionType.Oil: return "oil";
            case ConditionType.Recall: return "recall";
            case ConditionType.Rego: return "rego";
            case ConditionType.Wash: return "wash";

            //case ConditionType.Engine:
            case ConditionType.Service:
                return "service";

            //case ConditionType.TyrePressure:
            //case ConditionType.TyreRotation:
            case ConditionType.Tyres:
                return "tyres";
            
            case ConditionType.WiperBlades: return "windscreen";
            case ConditionType.Brakes: return "brakes";

            default: return "unknown";
        }
    }    

    /**
     * Gets a string representation of the enum for Google Tag Manager
     * @param type 
     * @returns 
     */
    export function toGoogleTagString( type: ConditionType ): string
    {
        switch( type )
        {
            //case ConditionType.Engine: return "engine";
            case ConditionType.Battery: return "battery";
            //case ConditionType.Oil: return "oil";
            case ConditionType.Recall: return "recall";
            case ConditionType.Service: return "service";
            case ConditionType.Tyres: return "tyres";
            //case ConditionType.TyrePressure: return "tyre-pressure";
            //case ConditionType.TyreRotation: return "tyre-rotation";
            case ConditionType.Rego: return "rego";
            case ConditionType.Wash: return "wash";
            case ConditionType.WiperBlades: return "wiper-blades";
            case ConditionType.Brakes: return "brakes";
            default: return "unknown";
        }
    }    
}